const Client = () => import('../views/ClientManage/client/index.vue');
const Contact = () => import('../views/ClientManage/client/pages/contact.vue');
const Doctor = () => import('../views/ClientManage/doctor/index.vue');
export default [
  {
    path: '/client',
    name: '医院管理',
    component: Client,
    meta: [{ name: '医院管理' }],
  },
  {
    path: '/client/contact',
    name: '联系人管理',
    component: Contact,
    meta: [{ name: '客户管理', path: '/client' }, {name: '联系人管理'}],
  },
  {
    path: '/doctor',
    name: '医生管理',
    component: Doctor,
    meta: [{ name: '医生管理' }],
  },
];
